import { useSelector } from 'react-redux';
import { selectAlertState } from './selectors';

export const useAlertInfo = () => useSelector(selectAlertState);
